// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Main-dashboard-container{
    display: flex;
    flex-direction: row-reverse;
}
.LeftSideBar{
    position: absolute;
    left: 0;
}
.Dashboard_Main_Containerxx{
    padding: 0px 32px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
    box-sizing: border-box;
  }
.RightSideBar{
    position: absolute;
    right: 0;
    width: calc(100% - 280px);
}
.date-btn{
    width: 128px;
height: 40px;
flex-shrink: 0;
border-radius: 8px;
border: 1px solid #D5DCE1;
background: #FFF;
box-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);
color: #405261;

font-size: 14px;
font-style: normal;
font-weight: 500;
line-height: 18px; /* 128.571% */
}
.selectdate-container{
    display: flex;
    justify-content: space-between;
    margin-top: 24px;
    align-items: center;
    margin-bottom: 41px;
}
.datepicket-container{
    display: flex;
    gap: 8px;
}
.state-text{
    color: #061522;

font-size: 24px;
font-style: normal;
font-weight: 500;
line-height: 18px; /* 75% */
}
.main-chart-container01{
    display: flex;
    justify-content: center;
}
.main-chart-container01 canvas{
    width: 100% !important
}
.ChatEmail-Container01{
    display: flex;
    gap: 8px;
        margin-top: 24px;
}
.Knwoledge-Main-Container{
    display: flex;
    gap: 8px;
            margin-top: 24px;
}
/* .datatable-container{
    border-radius: 8px;
border: 1px solid #E5E9EC;
background: #FFF;
} */
.Main_dashboard{
    padding: 0px 24px;
}

.Knowledge-row{
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 16px;
    
}

.Table-Container{
     margin: 24px 0px;
}

.Dashboard-Loader-Main{
    display: flex;
    justify-content: center;
    align-items: center;
}

.overview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;
  }
  
  .date-range-dropdown select {
    border: 1px solid #D5DCE1;
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 14px;
    color: #405261;
    background-color: #FFF;
    box-shadow: 0px 1px 2px rgba(6, 21, 34, 0.05);
    cursor: pointer;
  }
  
  .date-range-dropdown select:focus {
    outline: none;
    border-color: #66AFE9;
    box-shadow: 0 0 5px rgba(102, 175, 233, 0.6);
  }`, "",{"version":3,"sources":["webpack://./src/pages/Analytics/Chats/style.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2BAA2B;AAC/B;AACA;IACI,kBAAkB;IAClB,OAAO;AACX;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,sBAAsB;EACxB;AACF;IACI,kBAAkB;IAClB,QAAQ;IACR,yBAAyB;AAC7B;AACA;IACI,YAAY;AAChB,YAAY;AACZ,cAAc;AACd,kBAAkB;AAClB,yBAAyB;AACzB,gBAAgB;AAChB,iDAAiD;AACjD,cAAc;;AAEd,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,aAAa;AAChC;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,QAAQ;AACZ;AACA;IACI,cAAc;;AAElB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB,EAAE,QAAQ;AAC3B;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI;AACJ;AACA;IACI,aAAa;IACb,QAAQ;QACJ,gBAAgB;AACxB;AACA;IACI,aAAa;IACb,QAAQ;YACA,gBAAgB;AAC5B;AACA;;;;GAIG;AACH;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,SAAS;;AAEb;;AAEA;KACK,gBAAgB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,6CAA6C;IAC7C,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,4CAA4C;EAC9C","sourcesContent":[".Main-dashboard-container{\n    display: flex;\n    flex-direction: row-reverse;\n}\n.LeftSideBar{\n    position: absolute;\n    left: 0;\n}\n.Dashboard_Main_Containerxx{\n    padding: 0px 32px;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n    box-sizing: border-box;\n  }\n.RightSideBar{\n    position: absolute;\n    right: 0;\n    width: calc(100% - 280px);\n}\n.date-btn{\n    width: 128px;\nheight: 40px;\nflex-shrink: 0;\nborder-radius: 8px;\nborder: 1px solid #D5DCE1;\nbackground: #FFF;\nbox-shadow: 0px 1px 2px 0px rgba(6, 21, 34, 0.05);\ncolor: #405261;\n\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 18px; /* 128.571% */\n}\n.selectdate-container{\n    display: flex;\n    justify-content: space-between;\n    margin-top: 24px;\n    align-items: center;\n    margin-bottom: 41px;\n}\n.datepicket-container{\n    display: flex;\n    gap: 8px;\n}\n.state-text{\n    color: #061522;\n\nfont-size: 24px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 18px; /* 75% */\n}\n.main-chart-container01{\n    display: flex;\n    justify-content: center;\n}\n.main-chart-container01 canvas{\n    width: 100% !important\n}\n.ChatEmail-Container01{\n    display: flex;\n    gap: 8px;\n        margin-top: 24px;\n}\n.Knwoledge-Main-Container{\n    display: flex;\n    gap: 8px;\n            margin-top: 24px;\n}\n/* .datatable-container{\n    border-radius: 8px;\nborder: 1px solid #E5E9EC;\nbackground: #FFF;\n} */\n.Main_dashboard{\n    padding: 0px 24px;\n}\n\n.Knowledge-row{\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    gap: 16px;\n    \n}\n\n.Table-Container{\n     margin: 24px 0px;\n}\n\n.Dashboard-Loader-Main{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.overview-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 24px;\n  }\n  \n  .date-range-dropdown select {\n    border: 1px solid #D5DCE1;\n    border-radius: 8px;\n    padding: 8px 12px;\n    font-size: 14px;\n    color: #405261;\n    background-color: #FFF;\n    box-shadow: 0px 1px 2px rgba(6, 21, 34, 0.05);\n    cursor: pointer;\n  }\n  \n  .date-range-dropdown select:focus {\n    outline: none;\n    border-color: #66AFE9;\n    box-shadow: 0 0 5px rgba(102, 175, 233, 0.6);\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
